import React, { useMemo } from 'react';
import { getArrayValue, getObjectValue, getStringValue } from 'utilities';
import { FundShares } from './components';
import { WeightedShareValuesProps } from './types';

const WeightedShareValues = ({
  isLoading,
  isLoadingValuationSummary,
  isSaving,
  onSpreadsheetChange,
  shouldDisplayWeightedShareValues,
  weightedShareValuesNames,
  workbook,
  desiredWSVTableName: desiredWeightedShareValuesName,
}: WeightedShareValuesProps) => {
  const filteredSpreadsheets = useMemo(() => getArrayValue(Object.values(getObjectValue(workbook))).filter(spreadsheet =>
    weightedShareValuesNames.includes(getStringValue(spreadsheet?.name))
  ), [weightedShareValuesNames, workbook]);

  const spreadsheetsToRender = useMemo(() => {
    if (desiredWeightedShareValuesName) {
      return filteredSpreadsheets.filter(spreadsheet =>
        getStringValue(spreadsheet?.name).includes(desiredWeightedShareValuesName)
      );
    }
    return filteredSpreadsheets;
  }, [filteredSpreadsheets, desiredWeightedShareValuesName]);

  if (!shouldDisplayWeightedShareValues) return null;

  if (desiredWeightedShareValuesName && spreadsheetsToRender.length === 0) {
    return <p>table not found: {desiredWeightedShareValuesName}</p>;
  }

  return (
    <>
      {spreadsheetsToRender.map(weightedShareValuesSpreadsheet => (
        <FundShares
          isLoading={isLoading}
          isLoadingValuationSummary={isLoadingValuationSummary}
          isSaving={isSaving}
          key={getStringValue(weightedShareValuesSpreadsheet?.name)}
          onSpreadsheetChange={onSpreadsheetChange}
          weightedShareValuesSpreadsheet={weightedShareValuesSpreadsheet}
          workbook={workbook}
        />
      ))}
    </>
  );
};

export default WeightedShareValues;
